import { render } from "./Check.vue?vue&type=template&id=28e6c982&scoped=true"
import script from "./Check.vue?vue&type=script&lang=js"
export * from "./Check.vue?vue&type=script&lang=js"

import "./Check.vue?vue&type=style&index=0&id=28e6c982&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e6c982"]])

export default __exports__